<div class="wrap-x wrap-l center">
    <div class="left w-4 w-12-m w-12-s p-l p-l-5-m p-b-4-s col-1">
        <div class="p-r-2-s">
            @if(!!popularSearches.length) {
            <h3 class="col-12 h3">{{popularSearchesTitle}}</h3>
            }
            <a *ngFor="let term of popularSearches"
               class="w-12 m-t col-11 p2"
               [routerLink]="['search', term]">{{ term }}</a>
        </div>
        @if(additionalTitle && additionalItems) {
        <div class="p-r-2-s m-t-8 m-t-10-s">
            <h3 class="col-12 h3">{{additionalTitle}}</h3>

            <href *ngFor="let item of additionalItems"
                  class="m-t col-11 p2 block"
                  [link]="item.link">
                {{item.text}}
            </href>
        </div>
        }
    </div>

    @if(trendingNowItems.length) {
    <div class="wrap-s w-8 w-12-m w-12-s m-t-8-m m-t-6-s p-r-5-m p-l-5-m left">
        <h3 class="w-12 p-l-5 p-l-0-m p-l-0-s p-b-2"
            [sizeClass]="'!SM: h3 col-12, SM: o1 uppercase col-1'">{{trendingNowTitle}}</h3>

        <div class="w-12 m-t m-t-1-s p-l-1-x p-l-1-l">
            <div *ngFor="let item of trendingNowItems; let isLast = last; let index = index"
                 class="c-4-set-x c-4-set-l c-6-set-m p-r-4-x p-r-4-l p-l-4-x p-l-4-l"
                 [ngClass]="isLast ? 'c-12-set-s m-t-4-s p-r-0-s' : 'c-6-set-s'">

                <product [searchTerm]="'autocomplete'"
                         [gtmImpressionTrack]="{productId: item.id, position: index+1, list: 'Search results',  numberOfResults: trendingNowItems.length}"
                         [gtmTrackProductClick]="{productId: item.id, position: index+1, list: 'Search results'}"
                         [modelId]="item.id"
                         [acItem]="item"
                         [canShowTieredPrice]="true">
                </product>
            </div>
        </div>
    </div>
    }
</div>